module.exports = __webpack_public_path__ + "img/aj-fftp.b965949f.jpg";